<template>
  <div>
    <b-container class="b-container">
      <b-row>
        <b-col md="8">
          <h1>{{this.$store.state.miscData.PageTitle}}</h1>
        </b-col>
        <b-col md="4" class="pb-3 pt-3">
          <SortBar id="sortBar"></SortBar>
        </b-col>
      </b-row>
      <b-row>
        <b-col xs="3">
          <Filters id="filters" v-bind:brand="$route.params.brand"></Filters>
        </b-col>
        <b-col md="9">
          <p></p>
          <b-row v-if="$store.state.loading" class="justify-content-center">
            <b-spinner label="Spinning">Bezig met laden...</b-spinner>
          </b-row>
          <p v-else-if="$store.getters.noResults">Geen resultaten. Probeer andere filters.</p>
          <!-- <p v-else v-for="job in $store.getters.filteredJobs" v-bind:key="job.Id">omg a job</p> -->
          <JobCard
            v-else
            v-for="job in $store.getters.slicedFilteredJobs"
            v-bind:job="job"
            v-bind:key="job.Id"
          />
        </b-col>
      </b-row>
    </b-container>
    <FilterButtonAndModal id="filterButtonAndModal"></FilterButtonAndModal>
  </div>
</template>
<script>
import JobCard from "../components/JobOverviewPage/JobCard.vue";
import Filters from "../components/JobOverviewPage/Filters.vue";
import SortBar from "../components/JobOverviewPage/SortBar.vue";
import FilterButtonAndModal from "../components/JobOverviewPage/FilterButtonAndModal.vue";
export default {
  name: "JobsOverviewPage",
  components: {
    JobCard,
    Filters,
    SortBar,
    FilterButtonAndModal
  },
  async mounted() {
    this.isBusy = true;
    try {
      await this.$store.dispatch("load");
    } catch (ex) {
      this.error = "Failed to load data";
    } finally {
      this.isBusy = false;
    }
  }
};
</script>
<style scoped>
/* shared */
#filterButtonAndModal {
  display: none;
}
/* > 992px*/
@media screen and (min-width: 992px) {
}

/* =< 767 */
@media screen and (max-width: 767px) {
  #filterButtonAndModal {
    display: block;
  }
  #filters {
    display: none;
  }
  #sortBar {
    display: none;
  }
}
</style>